import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import InstallPrompt from '@/components/pwa/InstallPrompt';
import RequireAuth from '@/components/auth/RequireAuth';
import LoginPage from '@/pages/LoginPage';
import MatchesPage from '@/pages/MatchesPage';
import MapPage from '@/pages/MapPage';
import ScoutPage from '@/pages/ScoutPage';
import FavoritesPage from '@/pages/FavoritesPage';
import ClubsPage from '@/pages/ClubsPage';
import ProfilePage from '@/pages/ProfilePage';
import MatchDetailPage from '@/pages/MatchDetailPage';
import ClubDetailPage from '@/pages/ClubDetailPage';
import FanZonePage from '@/pages/FanZonePage';
import NewObservationPage from '@/pages/NewObservationPage';
import DetailedObservationPage from '@/pages/DetailedObservationPage';
import NotFoundPage from '@/pages/NotFoundPage';

export default function App() {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <InstallPrompt />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<RequireAuth />}>
          <Route element={<Layout />}>
            <Route path="/" element={<MatchesPage />} />
            <Route path="/map" element={<MapPage />} />
            <Route path="/scout" element={<ScoutPage />} />
            <Route path="/favorites" element={<FavoritesPage />} />
            <Route path="/clubs" element={<ClubsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/match/:id" element={<MatchDetailPage />} />
            <Route path="/club/:id" element={<ClubDetailPage />} />
            <Route path="/fanzone/:id" element={<FanZonePage />} />
            <Route path="/observation/new" element={<NewObservationPage />} />
            <Route path="/observation/detailed" element={<DetailedObservationPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
